export const getScoreColorClass = (score: number) => {
  if (score >= 50) {
    return "bg-green-100 text-green-800";
  }

  return "bg-red-100 text-red-800";
};
